import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetInstitutionIdentityByIdRequest,
    GetInstitutionIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetInstitutionIdentityByIdResponse, GetInstitutionIdentityByIdResponse>,
) => response?.data?.institutionIdentity;
const getError = (
    response?: SWRResponse<GetInstitutionIdentityByIdResponse, GetInstitutionIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetInstitutionIdentityByIdResponse, GetInstitutionIdentityByIdResponse>,
) => ({});

const useInstitutionIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<GetInstitutionIdentityByIdResponse, GetInstitutionIdentityByIdResponse>
        | null
        | undefined,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetInstitutionIdentityByIdResponse> =>
            new GetInstitutionIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useInstitutionIdentityById;
